"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5690],{

/***/ 7802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FilterPoolCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89583);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72364);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(37946);
/* harmony import */ var services_apiClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81372);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40570);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13274);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  z-index: 10;\n  flex: 1;\n\n  & > img {\n    position: absolute;\n    width: 100%;\n    height: auto;\n    top: -300px;\n    left: 0;\n  }\n\n  & > div {\n    width: 100%;\n    max-width: 130em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 99;\n\n    & > div {\n      display: flex;\n      flex-direction: column;\n\n      background-color: #FBF9ED;\n      cursor: auto;\n      border-top-left-radius: 8px;\n      border-top-right-radius: 8px;\n      border-bottom-right-radius: 8px;\n      border-bottom-left-radius: 8px;\n      box-shadow: rgb(223, 223, 223) 4px 5px 4px 5px;\n\n      & h1 {\n        color: #000000;\n        font-size: large;\n        font-weight: bold;\n        padding: 16px 32px;\n        text-align: center;\n      }\n\n      & button {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        height: 42px;\n        border-radius: 4px;\n\n        & > *:last-child {\n          color: #ffffff;\n        }\n      }\n\n      & > div:last-child {\n        display: flex;\n        padding: 32px;\n        padding-top: 0;\n        flex-direction: row;\n        gap: 10px;\n\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n      }\n    }\n  }\n\n  & select {\n    border: none;\n    background-color: white;\n    text-decoration: none;\n    text-align: center;\n    padding: 1.5rem;\n    font-size: 1.2rem;\n    border-radius: 2rem;\n    transition: transform 0.3s;\n    height: 49px;\n    min-width: 150px;\n    border: solid 1px #cccccc;\n    outline: none;\n\n    &::-webkit-user-select {\n      color: red;\n    }\n  }\n\n  ",
        " {\n    & > div > div > div:last-child {\n      flex-direction: column;\n    }\n\n    & button {\n      margin-top: 2rem;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var periods = [
    {
        label: "Hoje",
        value: "today"
    },
    {
        label: "Esta Semana",
        value: "this_week"
    },
    {
        label: "Este M\xeas",
        value: "this_month"
    },
    {
        label: "Este Ano",
        value: "this_year"
    }, 
];
var states = [
    {
        label: "Acre",
        value: "AC"
    },
    {
        label: "Alagoas",
        value: "AL"
    },
    {
        label: "Amap\xe1",
        value: "AP"
    },
    {
        label: "Amazonas",
        value: "AM"
    },
    {
        label: "Bahia",
        value: "BA"
    },
    {
        label: "Cear\xe1",
        value: "CE"
    },
    {
        label: "Distrito Federal",
        value: "DF"
    },
    {
        label: "Esp\xedrito Santo",
        value: "ES"
    },
    {
        label: "Goi\xe1s",
        value: "GO"
    },
    {
        label: "Maranh\xe3o",
        value: "MA"
    },
    {
        label: "Mato Grosso",
        value: "MT"
    },
    {
        label: "Mato Grosso do Sul",
        value: "MS"
    },
    {
        label: "Minas Gerais",
        value: "MG"
    },
    {
        label: "Par\xe1",
        value: "PA"
    },
    {
        label: "Para\xedba",
        value: "PB"
    },
    {
        label: "Paran\xe1",
        value: "PR"
    },
    {
        label: "Pernambuco",
        value: "PE"
    },
    {
        label: "Piau\xed",
        value: "PI"
    },
    {
        label: "Rio de Janeiro",
        value: "RJ"
    },
    {
        label: "Rio Grande do Norte",
        value: "RN"
    },
    {
        label: "Rio Grande do Sul",
        value: "RS"
    },
    {
        label: "Rond\xf4nia",
        value: "RO"
    },
    {
        label: "Roraima",
        value: "RR"
    },
    {
        label: "Santa Catarina",
        value: "SC"
    },
    {
        label: "S\xe3o Paulo",
        value: "SP"
    },
    {
        label: "Sergipe",
        value: "SE"
    },
    {
        label: "Tocantins",
        value: "TO"
    }, 
];
function FilterPoolCard(param) {
    var onSearch = param.onSearch;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), filter = ref[0], setFilter = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), categories = ref1[0], setCategories = ref1[1];
    var loadCategories = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
        var ref, categories, normalized;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        services_apiClient__WEBPACK_IMPORTED_MODULE_3__/* .api.get */ .h.get("/pool-categories")
                    ];
                case 1:
                    ref = _state.sent(), categories = ref.data;
                    normalized = categories.map(function(param) {
                        var label = param.name, value = param.id;
                        return {
                            label: label,
                            value: value
                        };
                    });
                    setCategories(normalized);
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        loadCategories();
    }, [
        loadCategories
    ]);
    var handlerSearch = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        filter && (onSearch === null || onSearch === void 0 ? void 0 : onSearch(filter));
    }, [
        filter,
        onSearch
    ]);
    var handlerCleanSearch = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setFilter(undefined);
        onSearch === null || onSearch === void 0 ? void 0 : onSearch(undefined);
    }, [
        onSearch
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ExploreCard, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                children: "Explorar vaquinhas"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                        value: (filter === null || filter === void 0 ? void 0 : filter.period) ? undefined : {
                                            label: "Criadas em qualquer data",
                                            value: "Criadas em qualquer data"
                                        },
                                        isSearchable: false,
                                        onChange: function(newValue) {
                                            return setFilter(function(prev) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                                                    period: newValue.value
                                                });
                                            });
                                        },
                                        placeholder: "Per\xedodos",
                                        options: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(periods),
                                        styles: {
                                            control: function(base) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, base), {
                                                    borderRadius: 4,
                                                    width: "200px"
                                                });
                                            },
                                            input: function(base) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, base), {
                                                    height: 35
                                                });
                                            },
                                            container: function(base) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, base), {
                                                    fontSize: "1.3rem"
                                                });
                                            }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                        value: (filter === null || filter === void 0 ? void 0 : filter.state) ? undefined : {
                                            label: "Todas as localiza\xe7\xf5es",
                                            value: "Todas as localiza\xe7\xf5es"
                                        },
                                        isSearchable: false,
                                        onChange: function(newValue) {
                                            return setFilter(function(prev) {
                                                var ref;
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                                                    state: (ref = newValue === null || newValue === void 0 ? void 0 : newValue.value) !== null && ref !== void 0 ? ref : ""
                                                });
                                            });
                                        },
                                        placeholder: "Todas as localiza\xe7\xf5es",
                                        options: states,
                                        styles: {
                                            control: function(base) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, base), {
                                                    borderRadius: 4,
                                                    width: "200px"
                                                });
                                            },
                                            input: function(base) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, base), {
                                                    height: 35
                                                });
                                            },
                                            container: function(base) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, base), {
                                                    fontSize: "1.3rem"
                                                });
                                            }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                        value: (filter === null || filter === void 0 ? void 0 : filter.categoryId) ? undefined : {
                                            label: "Todas as categorias",
                                            value: "Todas as categorias"
                                        },
                                        isSearchable: false,
                                        onChange: function(newValue) {
                                            return setFilter(function(prev) {
                                                var ref;
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, prev), {
                                                    categoryId: (ref = newValue === null || newValue === void 0 ? void 0 : newValue.value) !== null && ref !== void 0 ? ref : ""
                                                });
                                            });
                                        },
                                        placeholder: "Todas as categorias",
                                        options: categories,
                                        styles: {
                                            control: function(base) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, base), {
                                                    borderRadius: 4,
                                                    width: "200px"
                                                });
                                            },
                                            input: function(base) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, base), {
                                                    height: 35
                                                });
                                            },
                                            container: function(base) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, base), {
                                                    fontSize: "1.3rem"
                                                });
                                            }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            onClick: handlerSearch,
                                            children: [
                                                "Buscar",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaSearch */ .U41, {
                                                    style: {
                                                        marginLeft: 5
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            style: {
                                                marginLeft: 10
                                            },
                                            onClick: handlerCleanSearch,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaTrash */ .Xm5, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
var ExploreCard = styled_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d6da6684-0"
})(_templateObject(), (0,utils_media__WEBPACK_IMPORTED_MODULE_5__/* .media */ .B)("<=tablet"));


/***/ }),

/***/ 91638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37946);
/* harmony import */ var public_pool_default_header_mobile_bg_support_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61911);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13274);
/* harmony import */ var utils_stringFormat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43620);
/* harmony import */ var utils_verification__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40520);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1rem;\n  width: 100%;\n  gap: 10px;\n  \n  h2 {\n    margin-top: 0 !important;\n    text-overflow: ellipsis !important;\n    overflow: hidden;\n    width: 90%;\n    font-size: 20px;\n    margin-right: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  width: 25%;\n  padding-right: 10px;\n  gap: 5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  width: 25%;\n  padding-right: 10px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  width: fit-content;\n  width: 400px;\n  height: 454px;\n  padding: 11px;\n  color: #000;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  text-overflow: ellipsis !important;\n\n  & > div {\n    &:first-child {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: #f5f5f5;\n      min-height: 200px;\n      border-radius: 8px;\n      margin-bottom: 1rem;\n    }\n    &:nth-child(2) {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n\n      & > div {\n        display: flex;\n        flex-direction: column;\n\n        & span {\n          text-overflow: ellipsis;\n        }\n      }\n    }\n    &:last-child {\n      margin-top: 1rem;\n      background-color: #f5f5f5;\n      border-radius: 8px;\n      display: flex;\n      flex-direction: row;\n      font-size: 14px;\n\n      & > div {\n        flex: 1;\n        padding: 8px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        text-align: center;\n        max-width: calc(100% / 3);\n\n        & strong {\n          margin: 0.3rem 0;\n        }\n\n        &:nth-child(2) {\n          border-left: 1px solid rgba(0, 0, 0, 0.06);\n          border-right: 1px solid rgba(0, 0, 0, 0.06);\n        }\n      }\n    }\n  }\n\n  ",
        " {\n    min-width: auto !important;\n    width: 300px !important;\n\n    & > div:last-child {\n      & span {\n        font-size: 10pt;\n      }\n\n      & strong {\n        font-size: 11pt !important;\n        width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  ",
        " {\n    min-width: auto !important;\n    width: 280px !important;\n\n    & > div:last-child {\n      & span {\n        font-size: 8pt;\n        width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n      & strong {\n        font-size: 11pt !important;\n        width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  font-size: 12px;\n\n  div {\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: column;\n  }\n\n  p {\n    margin-left: 15px;\n  }\n\n  img {\n    max-width: 16%;\n    border-radius: 50%;\n  }\n\n  ",
        " {\n    img {\n      max-width: 25%;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var PoolCard = function(param) {
    var data = param.data;
    var fontSize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var _Math;
        var ref, ref1;
        var values = [
            (0,utils_stringFormat__WEBPACK_IMPORTED_MODULE_5__/* .fontAdjusts */ .p)("".concat(data === null || data === void 0 ? void 0 : (ref = data.target) === null || ref === void 0 ? void 0 : ref.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL"
            })), 18),
            (0,utils_stringFormat__WEBPACK_IMPORTED_MODULE_5__/* .fontAdjusts */ .p)("".concat(data === null || data === void 0 ? void 0 : (ref1 = data.raised) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL"
            })), 18),
            (0,utils_stringFormat__WEBPACK_IMPORTED_MODULE_5__/* .fontAdjusts */ .p)("".concat(data === null || data === void 0 ? void 0 : data.supporters, "}"), 18), 
        ];
        return (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(values));
    }, [
        data
    ]);
    var fixedFee = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return Number(data.raised) * Number(data.percentageFee) / 100;
    }, [
        data
    ]);
    var convertValue = function(value) {
        if (!value) return 0;
        else return value / 100;
    };
    var formatAmount = function(value) {
        return value === null || value === void 0 ? void 0 : value.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL"
        });
    };
    var isVerified = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,utils_verification__WEBPACK_IMPORTED_MODULE_7__/* .isPoolVerified */ .t)(data);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: data.cover ? {
                    backgroundImage: "url(".concat(data.cover, ")"),
                    backgroundPosition: "top",
                    backgroundSize: "cover"
                } : {
                    backgroundImage: "url(".concat(public_pool_default_header_mobile_bg_support_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src, ")"),
                    backgroundPosition: "top",
                    backgroundSize: "80% auto",
                    backgroundRepeat: "no-repeat"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TitleContainer, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                    children: data.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BadgeContainer, {
                                    children: [
                                        isVerified && data.active !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VerificationBadge, {}),
                                        data.active === false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CompletedBadge, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Description, {
                            children: data.description
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: "Meta:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                style: {
                                    fontSize: fontSize
                                },
                                title: formatAmount(convertValue(data === null || data === void 0 ? void 0 : data.target)),
                                children: formatAmount(convertValue(data === null || data === void 0 ? void 0 : data.target))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: "Total arrecadado:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                style: {
                                    fontSize: fontSize
                                },
                                title: formatAmount(convertValue(data === null || data === void 0 ? void 0 : data.raised)),
                                children: formatAmount(convertValue(data === null || data === void 0 ? void 0 : data.raised) - Number(convertValue(fixedFee)))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: "Apoiadores:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                style: {
                                    fontSize: fontSize
                                },
                                title: "".concat(data.supporters),
                                children: data.supporters
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var TitleContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be4db65-0"
})(_templateObject());
var BadgeContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be4db65-1"
})(_templateObject1());
var VerificationBadge = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
        src: "/verificada.png",
        alt: "Verificada",
        width: "40",
        height: "40",
        style: {
            width: 65,
            height: 50
        }
    });
};
var CompletedBadge = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
        src: "/concluida.png",
        alt: "Conclu\xedda",
        width: "45",
        height: "50",
        style: {
            width: 45,
            height: 50
        }
    });
};
var VerificationBadgeContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be4db65-2"
})(_templateObject2());
var Container = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be4db65-3"
})(_templateObject3(), (0,utils_media__WEBPACK_IMPORTED_MODULE_4__/* .media */ .B)("<=tablet"), (0,utils_media__WEBPACK_IMPORTED_MODULE_4__/* .media */ .B)("<=phone"));
var Avatar = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be4db65-4"
})(_templateObject4(), (0,utils_media__WEBPACK_IMPORTED_MODULE_4__/* .media */ .B)("<=tablet"));
var Description = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-be4db65-5"
})(_templateObject5());
/* harmony default export */ __webpack_exports__["Z"] = (PoolCard);


/***/ })

}]);